import { render } from "./MealLogger.vue?vue&type=template&id=aea87a12&scoped=true"
import script from "./MealLogger.vue?vue&type=script&lang=js"
export * from "./MealLogger.vue?vue&type=script&lang=js"

import "./MealLogger.vue?vue&type=style&index=0&id=aea87a12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea87a12"]])

export default __exports__